import { Component, EventEmitter, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { DeviceService } from 'src/app/services/devices/device.service';
import { isRelaySchedulerDevice } from 'src/app/services/devices/device-type.util';
import { UserService } from 'src/app/services/user/user.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { ConnectorState } from 'src/assets/js/constants';
import { forkJoin, Observable, of } from 'rxjs';
import { mergeMap, map, concatMap, catchError, filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { LoadingPopupComponent } from 'src/app/components/ui/loading-popup/loading-popup.component';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { idTagInfo, LocalAuthorizationList } from 'src/app/shared/models/components.interface';
import { MatTableDataSource } from '@angular/material/table';
import * as L from 'leaflet';
import 'leaflet-control-geocoder';


@Component({
    selector: 'app-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
    standalone: false
})
export class GroupComponent  implements OnInit{

  breadCrumbs : any;

  allContainCTM: boolean = false;
  group: any;
  dataGroup: any = {}
  linkedDevices: any[] = [];
  // data: any[]=[];
  allStates = ConnectorState;
  modalLoad: any;
  updateStatus: number;
  status : any[] = []
  showStatus = false;
  modal : any;
  ampacity = 32;
  power = 0;
  url = '';
  portOccp = 0;
  loading : boolean = true;
  confirm = {
    power : false,
    reset : false,
    ocpp: false,
    rfid: false,
    wifi : false,
    password : false,
    cards : false,
    role : false,
    geolocation : false,
    fwupdate : false
  }

  selectAll = false;
  selectedDevices: any[] = [];

  chooseCfg : string = 'power';
  rfidEnabled = 0;
  rfidMode = 0;
  eocMode : string | 'any' | 'own' = 'own';
  messageDelCards = false;
  cardsMode : string | 'upload' | 'delete' = 'upload'
  ssid = '';
  wifiPass = '';
  newPass = '';
  accessPoint = 1;
  addBoxId : boolean  = false;
  master = '';
  masterName = '';
  next ='master';
  slaves : any[] = [];
  chargeError : number ;
  interface = 1;
  powerLine : number;
  powerR : number;
  powerS : number;
  powerT : number;
  ip = '';
  slave= true ;
  port: number;

  modules: any[] = [];
  modulesChecked: any[] = [];

  event = new EventEmitter();
  file: File;
  tagList : any;

  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['icon', 'estado', 'nombre', 'rol', 'firmware', 'toma1','toma2', 'potencia', 'spl','config','acciones'];
  sortField: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  orginalName :any[] = [];
  fileSelected : boolean = false;
  connectorsMennekes = [];
  userRole : string = '';
  roles = [
    {value: 'all', viewValue: 'All'},
    {value: 'read', viewValue: 'Read'},
    {value: 'write', viewValue: 'Write'},
    {value: 'owner', viewValue: 'Owner'},
  ];
  selectedRole = '';
  is3Ph = false;
  map: L.Map;
  marker: L.Marker;
  latitud: number = 40.4165;
  longitud: number = -3.70256;
  addressGeolocation: string = '';

  currentRoute: string = '';
  @ViewChild('configmodal', { static: true }) modalElement!: ElementRef;
  versionUrl: string = '';
  roleUpdate: string = 'user';
  typeUpdate: string = 'uni';
  userRoleDB: string = '';
  modulatorActiv = false;
  limitPower;
  mainMeter = 255;

  mainMeters = [
    {label: 'selectMeter', value: 255},
    {label: 'Contax 0643 BUS', value: 0},
    {label: 'TMC100', value: 1},
    {label: 'solarContax', value: 2}
  ]

  constructor(private _router: Router, private _modal: ModalService, private _devices: DeviceService, private route: ActivatedRoute,
    private _translate: TranslateService, private _dashboard: DashboardService, private _user: UserService){
      this._router.events.subscribe(() => {
        const urlSegments = this._router.url.split('/');
        this.currentRoute = urlSegments[urlSegments.length - 1] || ''; // Ruta hija actual
        switch (this.currentRoute) {
          case 'view':
          case 'settings':
            this.currentRoute = this.currentRoute;
            break;
          case 'map':
            this.currentRoute = 'map';
            break;
                      case 'costs':
            this.currentRoute = this.currentRoute;
            break;
          case 'groupstats':
            this.currentRoute = 'groupstats';
            break;
          default:
            this.currentRoute = 'group';
            break;
        }
      });
}

  ngOnInit() {
    var userInfoGetted = this._user.getUserInfoGetted();
    if(!userInfoGetted){
      this._user.getUserInfo().subscribe((userInfo) => {
        this._user.setUserInfo(userInfo);
        this.userRoleDB = userInfo.role || '';
      });
    }
    else{
      this.userRoleDB = userInfoGetted.role || '';
    }


    this.dataSource = new MatTableDataSource(this.dataGroup.devices);
    this.group = null
    this._dashboard.getBreadCrumbs().subscribe(
      data =>{
         this.breadCrumbs = data;
      }
    )

    this.route.params.subscribe(params => {

      this.chooseCfg = 'power';
      this.loading= true;

      this.group = params['group'] || null;


      if (this.group != null) {

        this.selectedDevices = [];
        this._devices.getGroup(this.group).subscribe(
          async updatedGroup => {
            this.dataGroup = updatedGroup;
            await this.sortArrayByName(this.dataGroup.subgroups, 'name');
            this._dashboard.replaceBreadCrumbs(this.breadCrumbs);

            this.dataGroup.devices.forEach(device => {
              this.selectedDevices.push({ serial: device.serial, check: false, name: device.name });
            });

            const relayDevices = this.dataGroup.devices.filter(device => isRelaySchedulerDevice(device));
            let pending = relayDevices.length;

            if (pending === 0) {
              this.dataGroup = { ...this.dataGroup };
            } else {
              relayDevices.forEach(device => {
                this._devices.getModuleInfo(device.serial, 'channel').subscribe({
                  next: (data) => {
                    device.channels = data.stat;
                    pending--;
                    if (pending === 0) {
                      this.dataGroup = { ...this.dataGroup };
                    }
                  },
                  error: () => {
                    pending--;
                    if (pending === 0) {
                      this.dataGroup = { ...this.dataGroup };
                    }
                  }
                });
              });
            }

            //this.sortData();
            this.selectedDevices.forEach(element => {


            });
            // Comprueba quue todos los seriales son EXT/CTM
            this.allContainCTM = this.selectedDevices.every(element =>
              element.serial.includes('CTM')
            );
            console.log('Todos los dispositivos contienen CTM:', this.allContainCTM);

            await this.sortArrayByName(this.selectedDevices, 'name');

            this.loading=false
          },
          error => {
            console.error('Error fetching data:', error);
          }
        );
      }
    });
  }



  // Método para recibir toda la configuración SPL desde show-group
  onSplConfigChanged(splConfig: {
    master: string,
    masterName: string,
    slaves: any[],
    chargeError: number,
    interface: number,
    powerLine: number,
    ip: string,
    port: number,
    powerR: number,
    powerS: number,
    powerT: number
  }) {
    console.log('Configuración SPL recibida desde show-group:', splConfig);
    this.master = splConfig.master;
    this.masterName = splConfig.masterName;
    this.slaves = splConfig.slaves;
    this.chargeError = splConfig.chargeError;
    this.interface = splConfig.interface;
    this.powerLine = splConfig.powerLine;
    this.powerR = splConfig.powerR;
    this.powerS = splConfig.powerS;
    this.powerT = splConfig.powerT;
    this.ip = splConfig.ip;
    this.port = splConfig.port;
  }

  // Método para recibir los modules desde show-group
  onModulesChanged(modules: any[]) {
    console.log('Modules recibidos desde show-group:', modules);
    this.modules = modules;
  }

  sortArrayByName(array, key) {
    return array.sort((a, b) => {
        const valorA = key.split('.').reduce((o, k) => (o?.[k] ?? ""), a).toString().toLowerCase();
        const valorB = key.split('.').reduce((o, k) => (o?.[k] ?? ""), b).toString().toLowerCase();
        return valorA.localeCompare(valorB);
    });
  }



  updateBreadCrumbs(alias: string, index: number): void {
    const currentBreadCrumbs = this.breadCrumbs;
    const updatedBreadCrumbs = currentBreadCrumbs.slice(0, index +1);
    this._dashboard.replaceBreadCrumbs(updatedBreadCrumbs )
    if (index === 0) {
      this._dashboard.setModoDashboard('list')
      this._router.navigate(['dashboard']);
    } else {
        this._router.navigateByUrl(`/dashboard/group/${alias}/map`)

      // this._router.navigate(['dashboard/group', alias]);
    }
  }


  configSPL(){

  }

  getLinkedDevices(subgroup){

    this._devices.getLinkedDevices(subgroup)
      .subscribe( data => {
          this.linkedDevices = data
      })
  }

  goToDevice(serial) {
    this._router.navigateByUrl(`/dashboard/device/${serial}`)
  }


  reset(){
      this.confirm.reset = false;
      this.showStatus = true;
      for (let index = 0; index < this.selectedDevices.length; index++) {
        if (this.selectedDevices[index].check){
          this.status[index] = 3;
          this._devices.reset( this.selectedDevices[index].serial, 'hard')
          .subscribe( data => {
            this.status[index] = 1;
          }, err => {
            console.log(err);
            this.status[index] = 2;
          }
        )
       }
      }
  }

  setLimitPower() {
    this.confirm.power = false;
    this.showStatus = true;
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check) {
        this.status[index] = 3;

        const ampacityCall = this._devices.setModuleCfg(this.selectedDevices[index].serial, { "ampacity": this.ampacity }, 'sys').toPromise();
        const splMeterCall = this._devices.setModuleCfg(this.selectedDevices[index].serial, { "splMeter": this.mainMeter }, 'spl').toPromise();
        if(this.modulatorActiv){
          const limitPowerCall = this._devices.setModuleCfg(this.selectedDevices[index].serial, { "limitPower": this.limitPower }, 'modulator').toPromise();
          Promise.all([ampacityCall, limitPowerCall, splMeterCall])
            .then((responses) => {
                this.status[index] = 1; // Success
            })
            .catch((err) => {
                this.status[index] = 2; // Error
            });
        }
        else{
          Promise.all([ampacityCall, splMeterCall])
            .then((responses) => {
                this.status[index] = 1; // Success
            })
            .catch((err) => {
                this.status[index] = 2; // Error
            });
        }
      }
    }
  }

  buscarConn(serial: string) : any[] {
    let conns: any[] = []

    this.dataGroup.devices.forEach(element => {
      if( serial == element.serial ){
        element.element.forEach( conn => {
          conns.push(conn.name)
        })
      }
    }
  );

    return conns

  }


  ocpp() {
      this.confirm.ocpp = false;
      this.showStatus = true;
      for (let index = 0; index < this.dataGroup.devices.length; index++) {
        if (this.selectedDevices[index].check){
          this.status[index] = 3;
          var body = {
            serverUrl: this.addBoxId && this.url !="" ?  this.url + this.dataGroup.devices[index].serial : this.url ,
            // serverUrl: this.url,
            port: this.portOccp
          }

          this._devices.setModuleCfg(this.dataGroup.devices[index].serial, body, 'ocpp')
            .subscribe(data => {
              this.status[index] = 1;
            }, err => {
              console.log(err);
              this.status[index] = 2;
            })
        }
      }
  }

  setRFID(){
    if(this.confirm.cards){
      this.setCards(this.cardsMode);
    }
    if(!this.confirm.rfid){
      return;
    }
    this.confirm.rfid = false;
    this.showStatus = true;
    var body = {
      enabled : this.rfidEnabled,
      rfid : this.rfidMode,
      eocMode : this.eocMode
    }
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        this.status[index] = 3;
        this._devices.setModuleCfg( this.selectedDevices[index].serial, body, 'rfid' )
        .subscribe( data => {
          this.status[index] = 1
        }, err => {
          this.status[index] = 2;
        } )
      }
    }
  }

  setWifi(){
    this.confirm.wifi = false;
    this.showStatus = true;
    var body = {
        staEssid: this.ssid,
        staPasswd: this.wifiPass
    }
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        this.status[index] = 3;
        this._devices.setModuleCfg( this.selectedDevices[index].serial, body, 'network' )
        .subscribe( data => {
          this.status[index] = 1
        }, err => {
          this.status[index] = 2;
        } )
      }
    }
  }

  setPassword(){
    this.confirm.password = false;
    this.showStatus = true;
    var body = {
      apPasswd: this.newPass,
      apEnabled : this.accessPoint
    }
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        this.status[index] = 3;
        this._devices.setModuleCfg( this.selectedDevices[index].serial, body, 'network' )
        .subscribe( data => {
          this.status[index] = 1
        }, err => {
          this.status[index] = 2;
        } )
      }
    }
  }

  toggleAllDevices(){
    this.selectedDevices.forEach(device => {
      // Solo marcar/desmarcar dispositivos que NO estén deshabilitados
      if (!this.deviceDisabled(device.serial)) {
        device.check = this.selectAll;
      }
      // Los dispositivos deshabilitados mantienen su estado actual (normalmente false)
    });
  }


  openModal(){
    this.showStatus = true;
    this.status = [];
    this.versionUrl = '';
    this.cancel();
  }

  cancel(){
    this.confirm = {
      power : false,
      reset : false,
      ocpp: false,
      rfid: false,
      wifi : false,
      password : false,
      cards : false,
      role : false,
      geolocation : false,
      fwupdate : false
    };
    this.cardsMode = 'upload';
    this.messageDelCards = false;
    this.showStatus = true;
    this.status = [];
  }

  checkAnyFieldTrue(): boolean {
    return Object.values(this.confirm).some(value => value === true);
  }

  messageConfirm(){
    if (this.confirm.power ) return "setPowerAll";
    if (this.confirm.reset) return "resetAll";
    if (this.confirm.ocpp) return "setOcppAll";
    if (this.confirm.rfid) return "setRfidAll";
    if (this.confirm.wifi) return "setWifiAll";
    if (this.confirm.password) return "setPassAll";
    if (this.confirm.cards) return "setCardsAll";
    if (this.confirm.role) return "setRoleAll";
    if (this.confirm.geolocation) return "¿Estás seguro de querer cambiar la geolocalización de todos los dispositivos seleccionados?";
    if (this.confirm.fwupdate) return "¿Estás seguro de querer actualizar el firmware de todos los dispositivos seleccionados?";
    return ''
  }

  changeMode(modo : string){
    if ( modo === 'touch'){ this.rfidEnabled = 1; this.rfidMode = 0};
    if ( modo === 'rfid') { this.rfidEnabled = 1; this.rfidMode = 1};
    if ( modo === 'off')  { this.rfidEnabled = 0};
  }

  setCards(modo :string ){
    this.confirm.cards = false;
    this.showStatus = true;
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        this.status[index] = 3;
        if ( modo === 'delete'){
          this._devices.deleteRfidListCard( this.selectedDevices[index].serial)
          .subscribe( data => {
            this.status[index] = 1;
          }, err => {
            this.status[index] = 2;
          } )
        }else{
          this._devices.modifyRfidListCards( this.selectedDevices[index].serial , this.tagList)
          .subscribe( data => {
            this.status[index] = 1;
          }, err => {
            this.status[index] = 2;
          } )
        }
      }
    }
  }



  sortData(){
    this.dataGroup.devices.sort((a, b) => {
      const modeA = a.spl.cfg.splMode;
      const modeB = b.spl.cfg.splMode;

      if (modeA === 1) return -1; // Coloca primero los 'splmode' con valor 1
      if (modeB === 1) return 1;

      if (modeA === 2) return -1; // Luego los 'splmode' con valor 2
      if (modeB === 2) return 1;

      return 0; // Finalmente los 'splmode' con valor 0
    });

  }

  home(){
    var currentUrl = this._router.url;
    const lastSegment = currentUrl.split('/').filter(Boolean).pop();
        if (lastSegment === 'map') {
          this._dashboard.setModoDashboard('map')
          this._router.navigate([`/dashboard`]);
        }
    this._dashboard.setUpdateSidebar();
  }

  viewGroup(group) {
    this._router.navigate(['view']);
  }
  // goToSPL(group : string){
  //   this._router.navigate(['/dashboard/splconfig', group]);
  // }
  goToSPL(serial : string){
    if (this.master != ''){
      this._devices.setSelectedGroupDevices(this.dataGroup.devices);
      this._router.navigateByUrl(`/dashboard/device/${serial}/spl`)
    }
  }
  goTodetailGroup(group){
    this._router.navigate(['/dashboard/newgroup', group]);
  }

  infoGroup(group){
    this._dashboard.setBreadCrumbs({
      name: group.name,
      alias: group.alias
    });
    this._router.navigate(['/dashboard/group', group.alias]);
  }

  detailGroup(group){
    this._dashboard.setBreadCrumbs({
      name: group.name,
      alias: group.alias
    });
    this._router.navigate(['/dashboard/newgroup', group.alias]);
  }

  onFileSelected(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      this.file = inputElement.files[0];
       this.onUpload();
    }
  }


  async onUpload() {
    const workbook = XLSX.read(await this.file.arrayBuffer());
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    let raw_dat = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    let result = this.filterDuplicatedItems(raw_dat);
    let idTagRpt = this.checkIdTag(raw_dat)

    if (idTagRpt < 1) {
      if (result.duplicateRows.length < 1) {
        if (this.checkInvalidDates(result.uniqueRows) > 0) {
          this.fileSelected = false;
          console.log('---- ERROR ----')
        } else {
          try {
            const raw_data = this.getStatusCodeString(raw_dat);
            const xlsCardsArray: LocalAuthorizationList[] = [];
            for (let i = 1; i < raw_data.length; i++) {
              if(raw_data[i].length > 1){
                const item = raw_data[i];
                const idTag = item[0];
                const expiryDate = item[1] ? moment(item[1]).format('YYYY-MM-DDTHH:mm') : '';
                const parentIdTag = item[2];
                const status = item[3] ? item[3] : 'Accepted';
                const tagInfo: idTagInfo = { parentIdTag, expiryDate, status };
                const lal: LocalAuthorizationList = { idTag: idTag, idTagInfo: tagInfo };
                xlsCardsArray.push(lal);
              }
            }
            this.tagList = this.formatJson(xlsCardsArray);
            this.fileSelected = true;
          } catch (error) {
            console.log(error);
          }
        }
      }
      else {
        console.log('---- ERROR ----');
      }
    }
    else {
          console.log('----- Error al cargar archivo de tarjetas ------- ');
    }
  }

  filterDuplicatedItems(data: any): { uniqueRows: any[][]; duplicateRows: any[][] } {
    var uniqueRows: any[][] = [];
    var duplicateRows: any[][] = [];
    var seenValues: { [key: string]: boolean } = {};
    for (var i = 0; i < data.length; i++) {
      var row = data[i];
      var value = String(row[0]);
      if (row.length > 0 && !seenValues[value]) {
        uniqueRows.push(row);
        seenValues[value] = true;
      } else if (row.length > 0) {
        duplicateRows.push(row);
      }
    }
    return { uniqueRows: uniqueRows, duplicateRows: duplicateRows };
  }

  checkIdTag(obj: any[]): number {
    let count = 0;
    for (let i = 0; i < obj.length - 1; i++) {
      const array = obj[i];
      if (array.length === 0 || array[0] === null || array[0] === undefined || array[0] === '') {
        count++;
      }
    }
    return count;
  }

  checkInvalidDates(dataObject){
    const datesArray: string[] = dataObject.slice(1).map((item: any) => item[1]);
    let falseCount: number = 0;
    datesArray.forEach((item) => {
      if (!this.isValidDate(item)) {
        falseCount++;
      }
    });
    return falseCount;
  }
  isValidDate(dateString) {
    return dateString === '' || dateString === undefined|| moment(dateString, 'YYYY-MM-DDTHH:mm', true).isValid();
  }

  getStatusCodeString(array: any){
    const statusMap: { [key: number]: string } = {
        0: 'Accepted',
        1: 'Rejected',
        2: 'Expired',
        3: 'Invalid',
        4: 'In transaction',
        5: 'No credit',
        // 6: 'Blocked',
        // 7: 'ConcurrentTx',
        // 8: 'NotDefined'
    };

    const newArray = array.map(innerArray => {
      return innerArray.map(element => {
          if (typeof element === 'number') {
              return statusMap[element] || '';
          }
          return element;
      });
  });
  return newArray;
}

formatJson(jsonData: any[]): { file: string } {
  const csvData = jsonData.reduce((acc, obj, i) => {
    const idTag = obj.idTag || '';
    const expiryDate = obj.idTagInfo?.expiryDate || '';
    const parentIdTag = obj.idTagInfo?.parentIdTag || '';
    const status = obj.idTagInfo.status ? this.getCodeFromStatus(obj.idTagInfo.status) : 0;
    const statusCode = status;
    const lineSeparator = i === 0 ? '\n' : '';
    return `${acc}${lineSeparator}${idTag};${expiryDate};${parentIdTag};${statusCode}\r\n`;
  }, '2\r');

  return { file: csvData };}


getCodeFromStatus(status: string): number | string {
  const statusMap: { [key: string]: number | string } = {
    'Accepted': 0,
    'Rejected': 1,
    'Expired': 2,
    'Invalid': 3,
    'In transaction': 4,
    'No credit': 5,
    //'Blocked': 6,
    //'ConcurrentTx': 7,
    //'NotDefined': 8
  };
  const code = statusMap[status];
  return code !== undefined ? code : '';
}

sortTable(field: 'name' | 'estado' | 'icon') {
  if (!this.dataGroup.devices) {
    return; // Evita errores si los datos aún no están cargados
  }

  this.sortField = field;
  this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';

  this.dataGroup.devices.sort((a, b) => {
    let valueA: any, valueB: any;

    switch (field) {
      case 'name':
        valueA = a.deviceInfo?.name?.toLowerCase() || '';
        valueB = b.deviceInfo?.name?.toLowerCase() || '';
        break;
      case 'estado':
        valueA = a.deviceInfo?.alive || 0;
        valueB = b.deviceInfo?.alive || 0;
        break;
      case 'icon':
        valueA = a.serial || '';
        valueB = b.serial || '';
        break;
    }

    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return this.sortDirection === 'asc'
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    }

    return this.sortDirection === 'asc'
      ? valueA - valueB
      : valueB - valueA;
  });

  this.dataSource.data = this.dataGroup.devices;
}


change(slave){
  this.slaves.forEach(element => {
    if (element.serial == slave.serial){
      element.checked = slave.checked
    }
  });
  this.slave = this.checkAnyFieldTrue2()
}

checkAnyFieldTrue2(): boolean {
  return this.slaves.some(element => element.checked);
}

nextSection(){
  this.next === 'master' ? this.next = 'slave' : this.next = 'master'
  this.slaves = this.dataGroup.devices
    .filter(device => device.serial !== this.master)
    .map(device => ({
      ...device,
      checked: true
    }));
}

save(){
  this.modalLoad=this._modal.open(LoadingPopupComponent);

  var bodyMaster = {
    splFactory : 2,
    splMode: 1, // 1 master 2 slave 0 deshabilitado
    splInterface: this.interface == 3 ? 3 : 1,
    splIp : this.ip,
    splPort: this.port,
    splLimitPower: this.powerLine,
    splSlaveFailPower: this.chargeError,
    // splLimitPowerByPhase:[this.powerR,this.powerS,this.powerT]
  }

  var bodySlave = { ...bodyMaster, splMode: 2 };

  this._devices.setModuleCfg(this.master, bodyMaster, 'spl' )
  .subscribe( (data)=> {
    this.modalLoad.close();
    console.log('uptade master spl ', data);
  }, err => {
    console.log(err);
    this.modalLoad.close();
  });
  this.slaves.forEach(element => {
    this._devices.setModuleCfg(element.serial, bodySlave, 'spl')
    .subscribe ( (data) => {
      console.log('uptade slave spl ', data);
    })
  });
}

setRole() {
  this.showStatus = true;
  for (let index = 0; index < this.selectedDevices.length; index++) {
    if (this.selectedDevices[index].check) {
      this.status[index] = 3;
      this._devices.assignDevices(
        this.selectedDevices[index].serial,
        this.userRole,
        this.selectedRole
      ).subscribe((data) => {
        console.log(`Dispositivo ${this.selectedDevices[index].serial} asignado con rol ${this.selectedRole} al usuario ${this.userRole}` );
        this.status[index] = 1
      }, error => {
        console.error(`Error al asignar el rol ${this.selectedRole} al dispositivo ${this.selectedDevices[index].serial}`, error);
        this.status[index] = 2
      });
    }
  }


}


goToSettings(serial, component){
  this._router.navigate(['dashboard/device', serial, 'settings', component]);

}

initMapWhenModalOpens() {
  setTimeout(() => {
    this.initMap();
    // this.reinitMap();
  }, 200); // espera a que el DOM esté visible
}


initMap(): void {
    this.map = L.map('mapGeolocation').setView([this.latitud, this.longitud], 17);

    // Capa base de OpenStreetMap
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(this.map);

    // Añadir marcador inicial
    this.marker = L.marker([this.latitud, this.longitud]).addTo(this.map);
    this.changeGeolocation(this.latitud, this.longitud);

    // Evento: hacer clic para mover marcador
    this.map.on('click', (e: L.LeafletMouseEvent) => {
      this.latitud = e.latlng.lat;
      this.longitud = e.latlng.lng;

      this.marker.setLatLng([this.latitud, this.longitud]);
      this.changeGeolocation(this.latitud, this.longitud);
    });

    // Añadir buscador con leaflet-control-geocoder
    (L.Control as any).geocoder({
      defaultMarkGeocode: false
    })
    .on('markgeocode', (e) => {
      const center = e.geocode.center;
      this.latitud = center.lat;
      this.longitud = center.lng;
      this.map.setView(center, 17);
      this.marker.setLatLng(center);
      this.changeGeolocation(this.latitud, this.longitud);
    })
    .addTo(this.map);
  }

  changeGeolocation(lat: number, lng: number): void {
    fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`)
      .then(res => res.json())
      .then(data => {
        this.addressGeolocation = data.display_name;
      })
      .catch(err => {
        console.error('Error en geolocalización inversa', err);
      });
  }


  setGeolocation(){
    this.confirm.geolocation = false;
    this.showStatus = true;
    var body = {
        "geoloc": {
        "coords": [this.latitud, this.longitud]
      }
    }
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        this.status[index] = 3;
        this._devices.setModuleCfg( this.selectedDevices[index].serial, body, 'clock' )
        .subscribe( data => {
          this.status[index] = 1
        }, err => {
          this.status[index] = 2;
        } )
      }
    }
  }

  setFwUpdate(){
    this.confirm.fwupdate = false;
    this.showStatus = true;
    var body = {
        "geoloc": {
        "coords": [this.latitud, this.longitud]
      }
    }
    for (let index = 0; index < this.selectedDevices.length; index++) {
      if (this.selectedDevices[index].check){
        this.status[index] = 3;
        this._devices.updateFw(this.selectedDevices[index].serial, this.versionUrl)
        .subscribe( data => {
          this.status[index] = 1
        }, err => {
          this.status[index] = 2;
        } )
      }
    }
  }

  openModalRoleFromChild(user: string) {
    this.chooseCfg = 'rol';
    this.userRole = user;
    document.querySelector('[data-bs-target="#configmodal"]')?.dispatchEvent(new Event('click'));
  }

  alert(text){
    console.log(text);
  }

  getLastVersion(){
    this._devices.getLatestVersion("device_mod", this.typeUpdate, this.roleUpdate)
      .subscribe(data => {
        this.versionUrl = data.url;
      })
  }

  activeModulator(){
    this.modulatorActiv=!this.modulatorActiv;
    if(!this.modulatorActiv){
      this.mainMeter = 255;
    }
  }

  async getModules(dataGroup ) {

    console.log(dataGroup?.devices);
    dataGroup?.devices.forEach(async element => {
      var modules = await this._devices.getModulesByDevice(element.serial).toPromise();
      this.modules.push({ device: element.serial, modules: modules });
    });
  }

  // Método que ejecuta getModules y luego checkModules en secuencia
  async initializeModulesAndCheck(dataGroup: any, moduleToCheck: string = 'power') {
    try {
      await this.getModules(dataGroup);
      // Pequeña pausa para asegurar que getModules termine completamente
      setTimeout(() => {
        this.checkModules(moduleToCheck);
      }, 100);
    } catch (error) {
      console.error('Error al inicializar módulos:', error);
    }
  }

  checkModules(moduleToCheck: string) {
    this.modulesChecked = [];

    this.modules.forEach(deviceData => {
      let hasRequiredModules = false;

      if (moduleToCheck === 'power') {
        // Para 'power' necesita tener tanto 'sys' como 'modulator'
        const hasSys = deviceData.modules.some(module => module.topic_name === 'sys');
        const hasModulator = deviceData.modules.some(module => module.topic_name === 'modulator');
        hasRequiredModules = hasSys && hasModulator;
      } else {
        // Para otros módulos, buscar el módulo específico
        hasRequiredModules = deviceData.modules.some(module => module.topic_name === moduleToCheck);
      }
      if (hasRequiredModules) {
        this.modulesChecked.push({
          device: deviceData.device,
          module: moduleToCheck
        });
      }
    });

    // Después de verificar módulos, desmarcar dispositivos que estén deshabilitados
    this.selectedDevices.forEach(device => {
      if (this.deviceDisabled(device.serial)) {
        device.check = false;
      }
    });
  }

  hideViewTab(): boolean {
    const name = this.dataGroup?.name;
    return name === 'XEOLUM' || name === 'ASTRO MCB' || this.isRelaySchedulerGroup(name);
  }

  hideGroupStatsTab(): boolean {
    return this.isRelaySchedulerGroup(this.dataGroup?.name);
  }

  private isRelaySchedulerGroup(groupName: string | null | undefined): boolean {
    const name = String(groupName || '').trim();
    return name.startsWith('ANC+') || name.toLowerCase().startsWith('datalog');
  }

  deviceDisabled(serial): boolean {
    // Buscar si el serial está en modulesChecked
    const deviceFound = this.modulesChecked.find(element => element.device === serial);
    if (deviceFound) {
      return false; // Habilitado
    } else {
      return true;  // Deshabilitado
    }
  }
}
